<template lang="html">
  <b-col md="5" lg="3" xl="2" class="recommendation-info">
    <p><span class="reportLabel">Service</span>{{ recommendation.service }}</p>
    <p><span class="reportLabel">Report Publish Date</span>{{ formattedDate }}</p>
    <p><span class="reportLabel">Report Number</span>{{ recommendation.reportNumber }}</p>
    <p><span class="reportLabel">Recommendation Number</span>{{recommendation.number}}</p>
    <p v-if="!isMedical">
      <span class="reportLabel">Implementation Status</span><span class="implementationStatus pt-1 pb-1" :class="getImplementationStatusClass(recommendation)">{{ recommendation.implementationStatus }}</span>
    </p>
    <div v-if="!isMedical" class="custom-control">
      <div class="custom-switch">
        <input type="checkbox" @click="toggleFinding()" class="custom-control-input" :id="'showFindings-' + recommendation.number">
        <label class="custom-control-label reportLabel pt-1" :for="'showFindings-' + recommendation.number" v-html="findingButtonText"></label>
      </div>
      <div class="custom-switch">
        <input type="checkbox" @click="toggleResponse()" class="custom-control-input" :id="'showResponses-' + recommendation.number">
        <label class="custom-control-label reportLabel pt-1" :for="'showResponses-' + recommendation.number" v-html="buttonText"></label>
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  props: ['recommendation', 'isMedical'],
  data() {
    return {
      showResponses: false,
      showFindings: false
    }
  },
  computed: {
    buttonText() {
      if (this.showResponses) {
        return 'Hide Responses'
      }
      return 'Show Responses'
    },
    findingButtonText() {
      if (this.showFindings) {
        return 'Hide Findings'
      }
      return 'Show Findings'
    },
    formattedDate() {
      let date = new Date(this.recommendation.publishedDate)
      date = date.toLocaleString('default', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      })
      return date
    }
  },
  methods: {
    getImplementationStatusClass(recommendation) {
      if(recommendation.implementationStatus === null || typeof recommendation.implementationStatus === 'undefined') return
      return recommendation.implementationStatus.replace(/ /g,'_').toLowerCase()
    },
    toggleResponse() {
      this.showResponses = !this.showResponses
      this.$emit('toggleResponse', this.showResponses)
    },
    toggleFinding() {
      this.showFindings = !this.showFindings
      this.$emit('toggleFinding', this.showFindings)
    }
  }
}
</script>

<style lang="css" scoped>
.custom-control {
  padding-left: 0;
}

.reportLabel {
  display: block;
  font-family: "Nunito", Arial, sans-serif;
  color: #223d6b;
  font-weight: bold;
  font-size: 0.8rem;
}

.recommendationText {
  font-size: .8rem;
}

.implementationStatus {
  display: block;
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
}

.not_implemented {
  background-color: #E79E94;
  color: black;
}

.partially_implemented {
  background-color: #ede8af;
}

.fully_implemented {
  background-color: #147A4C;
  color: white;
}

.pending {
  background-color: #929292;
  color: white;
}

.will_not_implement {
  background-color: #BF211E;
  color: white;
}

.no_longer_applicable, .none {
  background-color: #C7C3C5;
  color: white;
}
</style>
